<template>
  <div class="apply-container">
    <div class="apply-top-container">
      <div class="apply-top-title">
        {{ languages.softwareApplication.request }}
      </div>
      <div class="apply-input-container">
        <div class="apply-input-desc">{{ languages.softwareApplication.name }}</div>
        <el-input
          :value="softwareName"
          clearable
          :placeholder="languages.softwareApplication.exp + ' Visio'"
          @input="setSoftwareName"
        ></el-input>
        <div class="apply-confirm-group">
          <el-button
            v-if="!isConfirming"
            type="primary"
            :loading="searchLoading"
            @click="toSubmit"
            >{{ languages.softwareApplication.submit }}</el-button
          >
          <el-button v-if="isConfirming" @click="toCancel">{{
            languages.softwareApplication.cancel
          }}</el-button>
          <el-button v-if="isConfirming" :loading="applyLoading" type="primary" @click="onSubmit">{{
            existSoftList.length > 0
              ? languages.softwareApplication.submitEnforce
              : languages.softwareApplication.confirm
          }}</el-button>
        </div>
      </div>
      <div class="apply-warn-content" v-show="existSoftList.length > 0">
        <div class="apply-warn-text">
          {{ languages.softwareApplication.existSoftApplyWarn1 }}{{ softwareName
          }}{{ languages.softwareApplication.existSoftApplyWarn2 }}
        </div>
        <div class="apply-warn-text apply-warn-underline" @click="toSoftPage">
          {{ languages.softwareApplication.toInstall }}
        </div>
      </div>
      <div class="apply-input-container">
        <div class="apply-info-name">{{ languages.softwareApplication.seat }}</div>
        <div class="apply-info-data">{{ seat }}</div>
        <div class="apply-info-name">{{ languages.softwareApplication.ext }}</div>
        <div class="apply-info-data">{{ phone }}</div>
        <el-button class="apply-info-edit" type="text" @click="ModifyVisible = true">
          {{ languages.softwareApplication.modify }}
        </el-button>
      </div>
    </div>
    <div class="apply-bottom-container">
      <div class="apply-bottom-title">
        {{ languages.softwareApplication.wanted }}
        <span>{{ languages.softwareApplication.wantTips }}</span>
      </div>
      <el-tooltip :content="languages.softwareApplication.reload" placement="left" effect="light">
        <div class="apply-bottom-reload" @click="getRankList">
          <i class="el-icon-refresh-right"></i>
        </div>
      </el-tooltip>
      <el-carousel
        class="apply-rank-container"
        indicator-position="outside"
        height="326px"
        :autoplay="false"
      >
        <el-carousel-item v-for="(item, index) in rankList" :key="index">
          <el-row>
            <el-col :span="12">
              <el-row>
                <div v-for="(rank, idx) in item" :key="idx">
                  <el-col v-if="idx - 5 < 0">
                    <rank-bar
                      style="margin: 2px 0 0 30px"
                      :detail="rank"
                      :index="idx + index * 10"
                      :languages="languages.softwareApplication"
                    ></rank-bar>
                  </el-col>
                </div>
              </el-row>
            </el-col>
            <el-col :span="12">
              <el-row>
                <div v-for="(rank, idx) in item" :key="idx">
                  <el-col v-if="idx - 5 >= 0">
                    <rank-bar
                      style="margin: 2px 0 0 10px"
                      :detail="rank"
                      :index="idx + index * 10"
                      :languages="languages.softwareApplication"
                    ></rank-bar>
                  </el-col>
                </div>
              </el-row>
            </el-col>
          </el-row>
        </el-carousel-item>
      </el-carousel>
    </div>
    <modify-dialog
      :languages="languages.softwareApplication"
      :seat="seat"
      :phone="phone"
      :show="ModifyVisible"
    ></modify-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import ModifyDialog from 'components/dialogs/ModifyDialog.vue';
import RankBar from '../../components/RankBar.vue';
import { ubtRegister, ubtSendTrace } from '../../utils/ubt';

export default {
  components: {
    RankBar,
    ModifyDialog,
  },
  data() {
    return {
      softwareName: '',
      rankList: [],
      isConfirming: false,
      applyLoading: false,
      submitData: {},
      seat: '',
      phone: '',
      ModifyVisible: false,
      searchLoading: false,
      existSoftList: [],
    };
  },
  provide() {
    return {
      applicationTemplate: this,
    };
  },
  computed: {
    ...mapState(['languages', 'softRankingList', 'pvId']),
  },
  methods: {
    ...mapMutations([
      'setPageNow',
      'setErrorTips',
      'setErrorType',
      'setHomeHidden',
      'setSearchHidden',
      'setShowFooter',
      'setDebugInfos',
      'setRedirectMode',
      'setSoftSearch',
    ]),
    ...mapActions([
      'softApply',
      'getVoteSoft',
      'getSoftRankingList',
      'toVoteSoft',
      'saveLog',
      'searchSoft',
      'getSoftSearch',
    ]),
    hideModifyDialog() {
      this.ModifyVisible = false;
    },
    submitModify(seat, phone) {
      this.seat = seat;
      this.phone = phone;
      this.ModifyVisible = false;
    },
    async toSubmit() {
      if (this.softwareName.trim() === '') {
        this.$message.warning(this.languages.softwareApplication.softTip);
        this.isConfirming = false;
        return;
      }
      this.searchLoading = true;
      const softList = await this.searchSoft(this.softwareName);
      this.existSoftList = softList;
      this.searchLoading = false;
      this.submitData.softwareName = this.softwareName;
      this.submitData.lan = this.languages.lan;
      this.submitData.seat = this.seat;
      this.submitData.phone = this.phone;
      this.isConfirming = true;
    },
    async voteRank(data) {
      const voteResult = await this.toVoteSoft(data.softName);
      if (voteResult !== 'success') {
        this.$message.warning(this.languages.softwareApplication.submitFail);
        this.setErrorTips('SoftwareApplication > voteRank failed');
        this.setDebugInfos([
          'SoftwareApplication > voteRank',
          `voteRank failed: ${voteResult.data}`,
        ]);
        this.saveLog({
          title: 'api_error',
          target: 'voteRank',
          description: voteResult.data,
        });
        return;
      }
      this.rankList.some((element) => {
        const rankItem = element;
        const index = rankItem.findIndex((item) => item.softName === data.softName);
        if (index !== -1) {
          rankItem[index].isVoted = '1';
          rankItem[index].voteNum += 1;
        }
        return index !== -1;
      });
      // await this.getRankList();
    },
    toCancel() {
      this.isConfirming = false;
      this.existSoftList = [];
    },
    async onSubmit() {
      this.applyLoading = true;
      console.log(this.submitData);
      const result = await this.softApply({ type: 'add', data: this.submitData });
      console.log('result >>> ', result);
      this.existSoftList = [];
      if (result.status === 'success') {
        ubtSendTrace(245694, 'other_sw', 'click', this.softwareName, '', 'eventhelp', this.pvId);
        this.$message.success(this.languages.softwareApplication.success);
        this.saveLog({
          title: 'SoftwareApplication',
          lan: this.languages.lan,
          softwareName: this.softwareName,
          target: 'Submit Application',
          description: 'Success',
        });
        this.softwareName = '';
      } else {
        this.setErrorTips('SoftwareApplication > Submit Application failed');
        this.saveLog({
          title: 'SoftwareApplication',
          lan: this.languages.lan,
          softwareName: this.softwareName,
          target: 'Submit Application',
          description: 'Failed',
        });
        this.$message.warning(this.languages.softwareApplication.submitFail);
      }
      this.applyLoading = false;
      this.isConfirming = false;
      this.getRankList();
    },
    async queryUserInfos() {
      const userBaseInfo = await this.softApply({ type: 'baseinfo' });
      if (userBaseInfo.status === 'success') {
        const userInfo = userBaseInfo.data;
        this.submitData.companyName = userInfo.companyname;
        this.submitData.location = userInfo.workshop;
        this.submitData.deskCode = userInfo.mostpc;
        this.seat = userInfo.seat;
        this.phone = userInfo.phone;
      }
    },
    async getRankList() {
      this.rankList = [];
      const getRankResult = await this.getSoftRankingList();
      if (getRankResult.status !== 'success') {
        this.$message.warning(this.languages.softwareApplication.getRanks);
        this.setErrorTips('SoftwareApplication > getRankList failed');
        this.setDebugInfos([
          'SoftwareApplication > getRankList',
          `voteRank failed: ${getRankResult.data}`,
        ]);
        this.saveLog({
          title: 'api_error',
          target: 'getRankList',
          description: getRankResult.data,
        });
        return;
      }
      const getVoteResult = await this.getVoteSoft();
      if (getVoteResult.status !== 'success') {
        this.setErrorTips('SoftwareApplication > getVoteResult failed');
        this.setDebugInfos([
          'SoftwareApplication > getVoteResult',
          `voteRank failed: ${getVoteResult.data}`,
        ]);
        this.saveLog({
          title: 'api_error',
          target: 'getVoteResult',
          description: getVoteResult.data,
        });
        return;
      }
      if (this.softRankingList.length > 0) {
        const mapRankList = this.softRankingList.map((rank) => {
          const soft = rank;
          const findIndex = getVoteResult.data.findIndex((item) => item.softName === soft.softName);
          soft.isVoted = findIndex !== -1 ? '1' : '0';
          return soft;
        });
        const dividList = [];
        const chunk = 10;
        const len = mapRankList.length;
        for (let i = 0; i < len; i += chunk) {
          dividList.push(mapRankList.slice(i, i + chunk));
        }
        this.rankList = dividList;
      }
    },
    async toSoftPage() {
      this.setRedirectMode(true);
      await this.setSoftSearch(this.softwareName);
      this.$router.push('/SoftwareInstall');
    },
    setSoftwareName(value) {
      console.log(value);
      this.existSoftList = [];
      this.isConfirming = false;
      this.softwareName = value;
    },
  },

  async created() {
    this.setPageNow('SoftwareApplication');
    this.setHomeHidden(false);
    this.setSearchHidden(true);
    this.setShowFooter(false);
    this.queryUserInfos();
    await this.getRankList();
    ubtRegister('Software Application');
  },
};
</script>

<style lang="scss" scoped>
.apply-confirm-group {
  .el-button {
    width: 80px;
    margin: 0 5px;
  }
  display: flex;
}
.apply-container {
  position: absolute;
  top: 70px;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  margin: 20px;
  color: #666;
  .apply-top-container {
    // height: 100%;
    position: relative;
    background: #f2f7ff;
    text-align: center;
    border-radius: 10px;
  }
  .apply-bottom-container {
    height: 100%;
    position: relative;
    margin-top: 20px;
    background: #f2f7ff;
    text-align: center;
    border-radius: 10px;
  }

  .apply-top-title,
  .apply-bottom-title {
    font-weight: 700;
    position: absolute;
    left: 15px;
    top: 15px;
    span {
      font-weight: 400;
      margin-left: 10px;
    }
  }
  .apply-bottom-reload {
    color: #0080ff;
    position: absolute;
    cursor: pointer;
    right: 15px;
    top: 15px;
    i {
      font-weight: 700;
      font-size: 22px;
    }
  }

  .apply-input-container {
    width: 600px;
    margin: 20px auto 10px auto;
    display: flex;
    justify-content: center;
    align-items: center;
    .el-input {
      width: 300px;
    }
    .apply-input-desc {
      text-align: right;
      width: 150px;
      margin-right: 10px;
    }
    .apply-input-button {
      margin-left: 10px;
      width: 150px;
    }
    .apply-info-name {
      text-align: right;
      margin: 0 5px;
    }
    .apply-info-data {
      text-align: left;
      width: 150px;
    }
    .apply-info-edit {
      text-align: left;
      color: #1466de;
      font-weight: 700;
      cursor: pointer;
    }
  }
  .apply-rank-container {
    width: 960px;
    position: absolute;
    overflow: hidden;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 40px auto 0px auto;
  }
  .apply-warn-content {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .apply-warn-text {
    display: flex;
    font-size: 14px;
    color: #f56c6c;
  }
  .apply-warn-underline {
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
